// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Approve Modal Container */
.DeleteLeaveModal_approveModal__iFQm5 {
  margin: 16px !important;
}

.DeleteLeaveModal_approveModal__iFQm5 .MuiDialog-paper {
  margin: 16px !important;
  width: 100% !important;
  max-width: 540px !important;
  border-radius: 12px !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  border: 1px solid #e5e7eb !important;
}

/* Modal Header */
.DeleteLeaveModal_modalHeader__nSny4 {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding-bottom: 8px !important;
  border-bottom: 1px solid var(--input, #e2e8f0) !important;
}

.DeleteLeaveModal_modalTitle__jynZE {
  color: var(--Slate-700, #334155);

  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px; /* 150% */
}

.DeleteLeaveModal_closeButton__xioUo {
  color: #6b7280 !important;
}

.DeleteLeaveModal_closeButton__xioUo:hover {
  background-color: #f3f4f6 !important;
}

/* Modal Content */
.DeleteLeaveModal_modalContent__qjjtm {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}

.DeleteLeaveModal_confirmationText__8inwr {
  color: var(--Slate-800, #1e293b);

  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  margin-bottom: 8px !important;
}

.DeleteLeaveModal_warningText__1O6Hl {
  color: var(--Slate-500, #64748b);

  font-family: var(--font-family-font-sans, Inter);
  font-size: 14px; /* changed to numeric */
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* approx 142.857% */
}

/* Modal Actions */
.DeleteLeaveModal_modalActions__4PD86 {
  padding: 24px 32px !important;
  border-top: 1px solid #f3f4f6 !important;
  gap: 16px !important;
}

/* Cancel Button */
.DeleteLeaveModal_cancelButton__5r4tr {
  border: none !important;
  color: #374151 !important;
  text-transform: none !important;
  font-weight: 500 !important;
  padding: 7px 24px !important;
  border-radius: 8px !important;
  background-color: rgba(241, 245, 249, 1) !important;
}

.DeleteLeaveModal_cancelButton__5r4tr:hover {
  border-color: #9ca3af !important;
  background-color: #e5e7eb !important;
}

.DeleteLeaveModal_deleteBtn__AFor3 {
  background-color: #dc2626 !important; /* Indigo-600 */
  color: #fff !important;
  text-transform: none !important;
  font-weight: 500 !important;
  padding: 7px 24px !important;
  border-radius: 8px !important;
  box-shadow: none !important;
}
.DeleteLeaveModal_deleteBtn__AFor3:hover {
  background-color: #a02020 !important;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .DeleteLeaveModal_approveModal__iFQm5 .MuiDialog-paper {
    margin: 8px !important;
    max-width: calc(100vw - 16px) !important;
  }

  .DeleteLeaveModal_modalActions__4PD86 {
    padding: 8px 16px 16px 16px !important;
    gap: 12px !important;
  }

  .DeleteLeaveModal_cancelButton__5r4tr,
  .DeleteLeaveModal_approveButton__a9ESo {
    padding: 10px 20px !important;
  }
}

/* Tablet (1024px) */
@media (max-width: 1024px) {
  .DeleteLeaveModal_modalTitle__jynZE {
    font-size: 19px;
  }

  .DeleteLeaveModal_confirmationText__8inwr {
    font-size: 15px;
  }

  .DeleteLeaveModal_approveModal__iFQm5 .MuiDialog-paper {
    max-width: 480px !important;
  }
}

/* Mobile (768px) */
@media (max-width: 768px) {
  .DeleteLeaveModal_approveModal__iFQm5 .MuiDialog-paper {
    margin: 12px !important;
    width: 95% !important;
    max-width: 420px !important;
  }

  .DeleteLeaveModal_modalHeader__nSny4,
  .DeleteLeaveModal_modalContent__qjjtm,
  .DeleteLeaveModal_modalActions__4PD86 {
    padding: 16px !important;
  }

  .DeleteLeaveModal_modalTitle__jynZE {
    font-size: 18px;
  }

  .DeleteLeaveModal_confirmationText__8inwr {
    font-size: 15px;
  }

  .DeleteLeaveModal_warningText__1O6Hl {
    font-size: 13px;
  }

  .DeleteLeaveModal_cancelButton__5r4tr,
  .DeleteLeaveModal_deleteBtn__AFor3 {
    padding: 10px 20px !important;
    width: 100%;
  }

  .DeleteLeaveModal_modalActions__4PD86 {
    flex-direction: column-reverse;
    gap: 12px !important;
  }
}

/* Small Mobile (480px) */
@media (max-width: 480px) {
  .DeleteLeaveModal_approveModal__iFQm5 .MuiDialog-paper {
    margin: 8px !important;
    width: 100% !important;
    max-width: 100% !important;
    border-radius: 10px !important;
  }

  .DeleteLeaveModal_modalHeader__nSny4 {
    padding: 14px 12px !important;
  }

  .DeleteLeaveModal_modalTitle__jynZE {
    font-size: 17px;
  }

  .DeleteLeaveModal_modalContent__qjjtm {
    padding: 12px !important;
  }

  .DeleteLeaveModal_confirmationText__8inwr {
    font-size: 14px;
    line-height: 20px;
  }

  .DeleteLeaveModal_warningText__1O6Hl {
    font-size: 12px;
  }

  .DeleteLeaveModal_modalActions__4PD86 {
    padding: 12px !important;
    gap: 10px !important;
  }

  .DeleteLeaveModal_cancelButton__5r4tr,
  .DeleteLeaveModal_deleteBtn__AFor3 {
    width: 100% !important;
    padding: 10px !important;
    font-size: 15px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperMostAdmin/GatePass/components/DeleteLeaveModal.module.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B,gGAAgG;EAChG,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;EAC9B,8BAA8B;EAC9B,yDAAyD;AAC3D;;AAEA;EACE,gCAAgC;;EAEhC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;;EAEhC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;;EAEhC,gDAAgD;EAChD,eAAe,EAAE,uBAAuB;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,oBAAoB;AACzC;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC,EAAE,eAAe;EACrD,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,oCAAoC;AACtC;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;IACE,sCAAsC;IACtC,oBAAoB;EACtB;;EAEA;;IAEE,6BAA6B;EAC/B;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,6BAA6B;IAC7B,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;;IAEE,sBAAsB;IACtB,wBAAwB;IACxB,0BAA0B;EAC5B;AACF","sourcesContent":["/* Approve Modal Container */\n.approveModal {\n  margin: 16px !important;\n}\n\n.approveModal :global(.MuiDialog-paper) {\n  margin: 16px !important;\n  width: 100% !important;\n  max-width: 540px !important;\n  border-radius: 12px !important;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;\n  border: 1px solid #e5e7eb !important;\n}\n\n/* Modal Header */\n.modalHeader {\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n  padding-bottom: 8px !important;\n  border-bottom: 1px solid var(--input, #e2e8f0) !important;\n}\n\n.modalTitle {\n  color: var(--Slate-700, #334155);\n\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 30px; /* 150% */\n}\n\n.closeButton {\n  color: #6b7280 !important;\n}\n\n.closeButton:hover {\n  background-color: #f3f4f6 !important;\n}\n\n/* Modal Content */\n.modalContent {\n  padding-top: 24px !important;\n  padding-bottom: 24px !important;\n}\n\n.confirmationText {\n  color: var(--Slate-800, #1e293b);\n\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px; /* 150% */\n  margin-bottom: 8px !important;\n}\n\n.warningText {\n  color: var(--Slate-500, #64748b);\n\n  font-family: var(--font-family-font-sans, Inter);\n  font-size: 14px; /* changed to numeric */\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* approx 142.857% */\n}\n\n/* Modal Actions */\n.modalActions {\n  padding: 24px 32px !important;\n  border-top: 1px solid #f3f4f6 !important;\n  gap: 16px !important;\n}\n\n/* Cancel Button */\n.cancelButton {\n  border: none !important;\n  color: #374151 !important;\n  text-transform: none !important;\n  font-weight: 500 !important;\n  padding: 7px 24px !important;\n  border-radius: 8px !important;\n  background-color: rgba(241, 245, 249, 1) !important;\n}\n\n.cancelButton:hover {\n  border-color: #9ca3af !important;\n  background-color: #e5e7eb !important;\n}\n\n.deleteBtn {\n  background-color: #dc2626 !important; /* Indigo-600 */\n  color: #fff !important;\n  text-transform: none !important;\n  font-weight: 500 !important;\n  padding: 7px 24px !important;\n  border-radius: 8px !important;\n  box-shadow: none !important;\n}\n.deleteBtn:hover {\n  background-color: #a02020 !important;\n}\n\n/* Responsive adjustments */\n@media (max-width: 600px) {\n  .approveModal :global(.MuiDialog-paper) {\n    margin: 8px !important;\n    max-width: calc(100vw - 16px) !important;\n  }\n\n  .modalActions {\n    padding: 8px 16px 16px 16px !important;\n    gap: 12px !important;\n  }\n\n  .cancelButton,\n  .approveButton {\n    padding: 10px 20px !important;\n  }\n}\n\n/* Tablet (1024px) */\n@media (max-width: 1024px) {\n  .modalTitle {\n    font-size: 19px;\n  }\n\n  .confirmationText {\n    font-size: 15px;\n  }\n\n  .approveModal :global(.MuiDialog-paper) {\n    max-width: 480px !important;\n  }\n}\n\n/* Mobile (768px) */\n@media (max-width: 768px) {\n  .approveModal :global(.MuiDialog-paper) {\n    margin: 12px !important;\n    width: 95% !important;\n    max-width: 420px !important;\n  }\n\n  .modalHeader,\n  .modalContent,\n  .modalActions {\n    padding: 16px !important;\n  }\n\n  .modalTitle {\n    font-size: 18px;\n  }\n\n  .confirmationText {\n    font-size: 15px;\n  }\n\n  .warningText {\n    font-size: 13px;\n  }\n\n  .cancelButton,\n  .deleteBtn {\n    padding: 10px 20px !important;\n    width: 100%;\n  }\n\n  .modalActions {\n    flex-direction: column-reverse;\n    gap: 12px !important;\n  }\n}\n\n/* Small Mobile (480px) */\n@media (max-width: 480px) {\n  .approveModal :global(.MuiDialog-paper) {\n    margin: 8px !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    border-radius: 10px !important;\n  }\n\n  .modalHeader {\n    padding: 14px 12px !important;\n  }\n\n  .modalTitle {\n    font-size: 17px;\n  }\n\n  .modalContent {\n    padding: 12px !important;\n  }\n\n  .confirmationText {\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  .warningText {\n    font-size: 12px;\n  }\n\n  .modalActions {\n    padding: 12px !important;\n    gap: 10px !important;\n  }\n\n  .cancelButton,\n  .deleteBtn {\n    width: 100% !important;\n    padding: 10px !important;\n    font-size: 15px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"approveModal": `DeleteLeaveModal_approveModal__iFQm5`,
	"modalHeader": `DeleteLeaveModal_modalHeader__nSny4`,
	"modalTitle": `DeleteLeaveModal_modalTitle__jynZE`,
	"closeButton": `DeleteLeaveModal_closeButton__xioUo`,
	"modalContent": `DeleteLeaveModal_modalContent__qjjtm`,
	"confirmationText": `DeleteLeaveModal_confirmationText__8inwr`,
	"warningText": `DeleteLeaveModal_warningText__1O6Hl`,
	"modalActions": `DeleteLeaveModal_modalActions__4PD86`,
	"cancelButton": `DeleteLeaveModal_cancelButton__5r4tr`,
	"deleteBtn": `DeleteLeaveModal_deleteBtn__AFor3`,
	"approveButton": `DeleteLeaveModal_approveButton__a9ESo`
};
export default ___CSS_LOADER_EXPORT___;
